import React from 'react';
import './Aboutus.css';
import { Link } from "react-router-dom";
import Domestic from './Image/img1.avif'
import aboutImage from '../images/about-us.jpg'
const Footer = () => {
  return (
    <div className="mainHome-container">
    
    <section className="product-categories" style={{height:"auto", paddingBottom:"50px"}}>

      <div className="Aboutus-container" >
        

        <div className="tranding-mid-container-contact-right">
            <div className='tranding-tittle'>
            About PKRVeda Global
            </div>
            <div className='tranding-mid-details'>
            Founded with a vision to establish a global network for trading metal scrap and agricultural products, PKRVeda Global has grown to become a trusted name in the industry.            </div>
            <div className='tranding-mid-details'>
            Our expertise spans across ferrous and non-ferrous metals, specialty scraps, agricultural commodities, and medical equipment. With years of experience and a commitment to quality, we've built lasting relationships with suppliers and clients worldwide.            </div>
            <div className='tranding-tittle'>
            Our Mission
            </div>
            <div className='tranding-mid-details'>
            To provide sustainable and efficient trading solutions that connect suppliers and buyers globally, ensuring quality products and reliable service at competitive prices.
            </div>
            <div className='tranding-tittle'>Our Values</div>
            <ul className='tranding-mid-details'>
              <li>Quality and reliability in every transaction</li>
              <li>Integrity and transparency in business practices</li>
              <li>Environmental responsibility through sustainable operations</li>
              <li>Customer satisfaction as our top priority</li>
            </ul>
          </div>
          <div className="tranding-mid-container-contact-left">
            <div className="tranding-pics">
                <img src={aboutImage} alt="" className='tranding-left-pics' />
            </div>

        </div>
        </div>
        <div className="stats-container">
      {stats.map((stat, index) => (
        <div className="stat-card" key={index}>
          <h3 className="stat-value">{stat.value}</h3>
          <p className="stat-label">{stat.label}</p>
        </div>
      ))}
    </div>
      
    </section>
    
    </div>
  );
};

export default Footer;

const stats = [
  { value: '15+', label: 'Years of Experience' },
  { value: '30+', label: 'Countries Served' },
  { value: '500+', label: 'Satisfied Clients' },
  { value: '10K+', label: 'Tons Traded Annually' },
];